export enum Module {
	czMaxPrice = 'czMaxPrice',
	czReimbursement = 'czReimbursement',
	roMaxPrice = 'roMaxPrice',
	skMaxPrice = 'skMaxPrice',
}
